import { ca } from '@cian/analytics';

export const trackClickRecommendation = (
  offerId: number,
  communicationId?: string,
  expert?: boolean,
  horizontal_scroll?: boolean,
  position?: number,
) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'similar_objects',
    action: 'click_similar_offers',
    label: 'user-based',
    page: {
      extra: {
        chat_id: 'chatbot',
        communication_id: communicationId,
        type: {
          expert,
          horizontal_scroll,
        },
      },
    },
    products: [
      {
        id: offerId,
        offerType: 'offer',
        position,
      },
    ],
  });
};

export const trackClickMessage = (offerId: number, chatId: string, messageId: string, communicationId?: string) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Chat',
    action: 'Click_sopr',
    label: 'Messages',
    page: {
      extra: {
        chat_id: chatId,
        messages_id: messageId,
        communication_id: communicationId,
        message_type: 'offer',
      },
    },
    products: [
      {
        id: offerId,
        offerType: 'offer',
        position: 1,
      },
    ],
  });
};

export function trackOfferMessageTeaserShow({
  offerId,
  block,
  mlSearchSessionGuid,
  batchid,
  position,
}: {
  offerId: number;
  block: string;
  mlSearchSessionGuid?: string;
  batchid?: number;
  position?: number;
}) {
  ca('teaser', {
    product: {
      id: offerId,
      name: 'show_card',
      extra: {
        offerType: 'offer',
        mlSearchSessionGuid,
        batchid,
      },
      position,
      screen: 'ChatScreen',
      block,
    },
  });
}

export const trackExpertButtonClick = (offerId: number, communicationId?: string, position?: number) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'ChatBot',
    action: 'Click_similar_offer_sopr',
    label: 'Expert',
    page: {
      extra: {
        chat_id: 'chatbot',
        communication_id: communicationId,
      },
    },
    products: [
      {
        id: offerId,
        offerType: 'offer',
        position,
      },
    ],
  });
};
